<template>
  <div>
    <el-dialog
      :visible.sync="dialsetting"
      width="80%"
      title="操作记录">
        <el-table :data="ooficeList" border>
            <el-table-column class="data-table" label="币种" prop="coinType"></el-table-column>
            <el-table-column class="data-table" label="手续费模式">
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == '0'?'模式一':'模式二'}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="手续费">
              <template slot-scope="scope">
                {{scope.row.withdrawFee}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="精度">
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == '0'?'--':scope.row.costPrecision}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="提现成本（USDT）">
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == '0'?'--':scope.row.cost}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="操作账户" prop="opUserId"></el-table-column>
            <el-table-column class="data-table" label="时间" prop="createTime"></el-table-column>
        </el-table>
        <el-pagination style="margin-top: 30px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginations.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="paginations.size"
      layout="total, sizes, prev, pager, next, jumper"
        :total="officTotal">
    </el-pagination>   
    </el-dialog>
  </div>
</template>
<script>
import '../store.js';
import Pagination from 'components/pagination';
import { mapState,mapActions } from 'vuex';
import {SHARE_TYPE} from '../constant.js'
export default {
  name: "batchsetting",
  components: {
    Pagination
  },
  data() {
    return {
      cycleList:[{a:1,b:2,c:3,d:4,f:5,g:6}],
      dialsetting:false,
      paginations: {
        page: 1,
        size: 10
      },
      id:null
    };
  },
  created(){
    // let data = {withdrawFeeConfigId:'123',...this.pagination}
    // this.getOfficeList(data);
  },
  methods: {
    ...mapActions('withdrawal', ['getOfficeList']),
    showData(id) {
      this.id = id;
      console.log(this.ooficeList)
      this.getOfficeList({withdrawFeeConfigId:id,opSourceType:1,...this.paginations})
        this.dialsetting = true
    },
    handleSizeChange(val) {
        this.paginations.size = val;
        this.getOfficeList({withdrawFeeConfigId:this.id,opSourceType:1,...this.paginations})
    },
    handleCurrentChange(val) {
        this.paginations.page = val;
        this.getOfficeList({withdrawFeeConfigId:this.id,opSourceType:1,...this.paginations})
    },
  },
  computed: {
    ...mapState('withdrawal', ['pagination','ooficeList','officTotal']),
  },
  watch: {
  },
  filters: {
  },
};
</script>
<style lang="less" scoped>
  
</style>
